//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const Organization = require('@/tbs/model/vo/Organization')
const DataConvertor = require('@/tbs/core/DataConvertor')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchNameMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchNameMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchNameMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        console.log('handleCreationComplete')
        /*if (this._bridge.isCreate()) {
            this.handleCreateSceneCreationComplete()
        }*/
        if (!this._bridge.isCreate()) {
            return
        }
        const organizationId = this._bridge.getRouteQuery('organizationId')
        if (organizationId == null) {
            // try to load the organization list 
            // to fetch the existed organization as the default one
            this.loadOrganizationList()
        }
        else {
            this.handleCreateSceneCreationComplete()
        }
    },
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        const self = this
        if (event.type == 'submit') {
            console.log('submit', event)
            const query = {}
            query.matchBrandArea = self._bridge.getRouteQuery('matchBrandArea')
            query.matchBrandAreaId = self._bridge.getRouteQuery('matchBrandAreaId')
            query.matchBrandLogoUrl = self._bridge.getRouteQuery('matchBrandLogoUrl')
            self._bridge.goToScene('OrgCreateMatch', null, ObjectFunc.mergeObject(query, event.data))
        }
        else if (event.type == 'navigate') {
            const query = self._bridge.getRouteQuery()
            if (self._bridge.getRouteName() == 'OrgCreateMatchName') {
                if (event.data.name == 'OrgListOrganization') {
                    query.organizationId = self.target().match.organizationId
                }
                else if (event.data.name == 'OrgListMatchBrand') {
                    query.organizationId = self.target().match.organizationId
                    query.organizationName = self.target().match.organizationName
                    query.organizationLogoUrl = self.target().match.organizationLogoUrl
                    query.organizationAreaId = self.target().match.organizationAreaId
                    query.organizationArea = self.target().match.organizationArea
                    self.target().match.brandId && (query.matchBrandId = self.target().match.brandId)
                }
            }
            self._bridge.goToScene(event.data.name, event.data.params, 
                ObjectFunc.mergeObject(query, event.data.query))
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteQuery('hideOrg') == 'true') {
            this._bridge.goToScene('OrgManageOrganization', {id: this._bridge.getRouteQuery('organizationId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleCreateSceneCreationComplete: function() {
        const self = this
        const organizationId = self._bridge.getRouteQuery('organizationId')
        if (organizationId) {
            self.target().match.organizationId = organizationId
            self.target().match.organizationName = self._bridge.getRouteQuery('organizationName')
            self.target().match.organizationLogoUrl = self._bridge.getRouteQuery('organizationLogoUrl')
            self.target().match.organizationAreaId = self._bridge.getRouteQuery('organizationAreaId')
            self.target().match.organizationArea = self._bridge.getRouteQuery('organizationArea')
        }
        const brandId = self._bridge.getRouteQuery('matchBrandId')
        if (brandId) {
            self.target().match.brandId = brandId
            self.target().match.brandName = self._bridge.getRouteQuery('matchBrandName')
            self.target().match.brandLogoUrl = self._bridge.getRouteQuery('matchBrandLogoUrl')
            self.target().match.year = (new Date).getFullYear().toString()
            let sessionMax = Number(self._bridge.getRouteQuery('matchSessionMax'))
            sessionMax = sessionMax ? sessionMax + 1 : 1
            self.target().match.session = sessionMax.toString()
        }
        console.log('@validate hideOrg', self._bridge.getRouteQuery('hideOrg'))
        if (self._bridge.getRouteQuery('hideOrg') == 'true') {
            // console.log('@from', self._bridge.getRouteQuery('from') === 'OrgManageOrganization')
            self.target().hideOrganization = true
        }
    },
    loadOrganizationList: function() {
        const self = this
        const convertor = new Organization()
        const wrapper = DataConvertor.wrapper(convertor)
        const source = convertor.view.query
        const service = 'query' + ObjectFunc.capitalizeFirstLetter(wrapper)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('query.data', service, e.data)
            // self.handleQueryService(e)
            if (e.data.result) {
                if (e.data.payload && e.data.payload.data.list.length > 0) {
                    const viewData = DataConvertor.transform(convertor, e.data.payload, 'query')
                    const selectedOrganization = viewData[0]
                    self._bridge.goToScene('OrgCreateMatchName', {}, {
                        organizationId: selectedOrganization.id,
                        organizationName: selectedOrganization.name,
                        organizationLogoUrl: selectedOrganization.logoUrl,
                        organizationAreaId: selectedOrganization.areaId,
                        organizationArea: selectedOrganization.area,
                    }, true)
                    self._bridge.reload()
                }
                else {
                    self.handleCreateSceneCreationComplete()
                }
            }
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET'
        })
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchNameMediator, BaseMediator);

module.exports = tbs_controller_MatchNameMediator